import { render, staticRenderFns } from "./DsMainLayout.vue?vue&type=template&id=f23a398c&"
import script from "./DsMainLayout.vue?vue&type=script&lang=js&"
export * from "./DsMainLayout.vue?vue&type=script&lang=js&"
import style0 from "./DsMainLayout.vue?vue&type=style&index=0&id=f23a398c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports